var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard",attrs:{"id":"custom-v-autocomplete"}},[_c('v-container',[_c('h1',{staticClass:"text-center"},[_vm._v("Welcome "+_vm._s(_vm.$getUserData().username)+" !!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }